// import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, TextField } from "@mui/material";
// import React from "react";
// import ToolTipComponent from "../../UniversalComponents/ToolTipComponent";
// import { Circle } from "@mui/icons-material";

// const AddFolderModal = ({
//   showAddFolderModal,
//   handleDialogClose,
//   folderName,
//   handleFolderNameChange,
//   colorOptions,
//   folderColor,
//   handleColorSelect,
//   handleSubmit,
// }) => {
//   return (
//     <Dialog open={showAddFolderModal} onClose={handleDialogClose}>
//       <DialogTitle>
//         Add Folder
//         <hr style={{ border: "1px solid #ddd", marginTop: "10px" }} />
//       </DialogTitle>
//       <DialogContent>
//         <div style={{ color: "#434852", fontSize: "14px" }} onContextMenu={() => window.alert("hello")}>
//           Folder Name{" "}
//           <ToolTipComponent text="Max 30 character limit allowed">
//             <span className="text-red-600 cursor-pointer">*</span>
//           </ToolTipComponent>
//         </div>
//         <TextField
//           fullWidth
//           value={folderName}
//           size="small"
//           onChange={handleFolderNameChange}
//           inputProps={{ maxLength: 20 }}
//         />
//         <div style={{ marginTop: "10px", color: "#434852", fontSize: "14px" }}>Folder Color</div>
//         <div style={{ display: "flex", marginTop: "5px", gap: "8px" }}>
//           {colorOptions.map((color) => (
//             <IconButton
//               key={color}
//               onClick={() => handleColorSelect(color)}
//               style={{
//                 border: folderColor === color ? "1px solid #1D4469" : "",
//                 padding: "3px",
//                 //  backgroundColor: folderColor === color ? color : "",
//               }}
//             >
//               <Circle style={{ color: color }} />
//             </IconButton>
//           ))}
//         </div>
//       </DialogContent>

//       <DialogActions>
//         <Button
//           onClick={handleDialogClose}
//           style={{
//             color: "#1D4469",
//             backgroundColor: "#eee",
//             border: "1px solid #eee",
//             textTransform: "none",
//             padding: "4px 15px",
//           }}
//         >
//           Cancel
//         </Button>
//         <Button
//           onClick={handleSubmit}
//           style={{
//             color: "#fff",
//             backgroundColor: "#1D4469",
//             border: "1px solid #4caf50",
//             textTransform: "none",
//             padding: "4px 15px",
//             opacity: folderName?.length === 0 ? 0.5 : 1,
//           }}
//           disabled={folderName?.length === 0}
//         >
//           Save
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default AddFolderModal;
import { Dialog, DialogActions, DialogContent, IconButton, TextField, Divider } from "@mui/material";
import React from "react";
import ToolTipComponent from "../../UniversalComponents/ToolTipComponent";
import { ReactComponent as CrossIcon } from "../../../assets/images/crossIcon.svg";
import { Circle } from "@mui/icons-material";
import ButtonGroup from "../../UniversalComponents/ButtonGroup";
import Button from "../../UniversalComponents/DefaultButton";

const AddFolderModal = ({
  showAddFolderModal,
  handleDialogClose,
  folderName,
  handleFolderNameChange,
  colorOptions,
  folderColor,
  handleColorSelect,
  handleSubmit,
}) => {
  return (
    <Dialog
      open={showAddFolderModal}
      onClose={handleDialogClose}
      PaperProps={{
        sx: {
          width: 400,
          borderRadius: 3,
          p: 0,
        },
      }}
    >
      {/* Header */}
      <div className="flex justify-between items-center p-4 pb-2">
        <p className="text-base font-medium text-gray-800">Add Folder</p>
        <IconButton onClick={handleDialogClose} size="small">
          <CrossIcon />
        </IconButton>
      </div>
      <Divider />

      {/* Content */}
      <DialogContent sx={{ px: 3, py: 2 }}>
        {/* Folder Name */}
        <div className="text-sm text-[#434852] mb-1">
          Folder Name{" "}
          <ToolTipComponent text="Max 30 character limit allowed">
            <span className="text-red-600 cursor-pointer">*</span>
          </ToolTipComponent>
        </div>

        <TextField
          fullWidth
          size="small"
          value={folderName}
          onChange={handleFolderNameChange}
          inputProps={{ maxLength: 20 }}
        />

        {/* Folder Color */}
        <div className="text-sm text-[#434852] mt-4 mb-1">Folder Color</div>
        <div className="flex items-center gap-2 mt-1 flex-wrap">
          {colorOptions.map((color) => (
            <IconButton
              key={color}
              onClick={() => handleColorSelect(color)}
              sx={{
                p: "4px",
                width: 30,
                height: 30,
                borderRadius: "50%",
                border: folderColor === color ? "2px solid #1D4469" : "1px solid transparent",
                "&:hover": {
                  border: "2px solid #A1A9B3",
                },
              }}
            >
              <Circle sx={{ color: color, fontSize: 20 }} />
            </IconButton>
          ))}
        </div>
        <Divider
          sx={{
            borderStyle: "dashed",
            borderColor: "#C5C5C5",
            my: 2,
          }}
        />

        {/* Selected Color Indicator */}
        <div className="flex items-center justify-end mt-3 gap-2">
          <span
            style={{
              width: "22px",
              height: "22px",
              borderRadius: "50%",
              border: "1px solid #ccc",
              backgroundColor: folderColor || "transparent",
            }}
          ></span>

          <span className="text-sm text-[#434852]">Selected</span>
        </div>
        {/* <Divider /> */}
      </DialogContent>

      {/* Actions */}

      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button
          variant="secondary"
          onClick={handleDialogClose}
          // sx={{
          //   textTransform: "none",
          //   color: "#1D4469",
          //   border: "1px solid #E0E0E0",
          //   backgroundColor: "#F5F5F5",
          //   px: 3,
          //   py: 0.5,
          //   borderRadius: "8px",
          //   "&:hover": {
          //     backgroundColor: "#EAEAEA",
          //   },
          // }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          disabled={folderName?.length === 0}
          sx={{
            textTransform: "none",
            color: "#fff",
            backgroundColor: "#1D4469",
            px: 3,
            py: 0.5,
            borderRadius: "8px",
            opacity: folderName?.length === 0 ? 0.6 : 1,
            "&:hover": {
              backgroundColor: "#173754",
            },
          }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddFolderModal;
